import React from 'react';
import ErrorService from '../../../services/ErrorService';
import InfoError from '../../../_shared/models/InfoError';
import ErrorUi from './ErrorUi';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  static getDerivedStateFromError(error) {
    if (error instanceof InfoError) {
      return { hasError: false };
    }
    return { hasError: true };
  }

  componentDidCatch(error) {
    ErrorService.trackError(error);
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return <ErrorUi />;
    }

    return children;
  }
}

export default ErrorBoundary;
